import { useI18n } from '@/i18n';

export function LazyFallback() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-40 items-center justify-center text-sm text-dp-muted">
      {t('wordleLoadingDict')}
    </div>
  );
}

export function StubPage({ messageKey }: { messageKey: 'privacyStub' | 'termsStub' }) {
  const { t } = useI18n();
  return (
    <div className="rounded-2xl border border-dp-line/60 bg-dp-surface/80 p-6 text-center shadow-sm">
      <p className="text-dp-ink">{t(messageKey)}</p>
    </div>
  );
}
